<icc-list [searchable]="true" [items]="accessories"
          [itemTemplate]="'itemImgTitleDescription'"
          (select)="selectAccessory($event)"
          itemImgHeight="medium"
          itemWidth="full"
          [ignoreTemplateWidth]="true"
          ></icc-list>
